import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { moduleName as recordsModuleName } from "../../records";
import { routeConfig } from "./routes";

export const vsName = "SlotTrak.Projects";

angular.module(vsName, [uiRouter, recordsModuleName]).config(routeConfig);

export default vsName;
